import * as Yup from "yup";

export default Yup.object().shape({
    id: Yup.number(),
    key: Yup.string().required("Name is required"),
    value: Yup.string().when("key", {
        is: key => typeof key === "string" && ["ai:allowedusers", "ai:doclingapikey"].includes(key.trim().toLowerCase()),
        then: Yup.string(),
        otherwise: Yup.string().required("Name is required")
    })
});
